import { useMutation, useQueryClient } from "@tanstack/react-query";
import { VENDOR_KEYS } from "./vendor.keys";
import { vendorService } from "./vendor.services";

export const useCreateVendor = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: vendorService.createVendor,
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: VENDOR_KEYS.GET_VENDORS({}),
      });
    },
  });
};

export const useUpdateVendor = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: vendorService.updateVendor,
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: VENDOR_KEYS.GET_VENDORS({}),
      });
    },
  });
};

export const useDeleteVendor = () => {
  return useMutation({
    mutationFn: vendorService.deleteVendor,
  });
};
